import { getOneButtonCapabilityValue } from './capabilityService';
import type { OneButtonUserCapabilityResponse } from '../../@types/oneButtonCapability';

/**
 * Angular Generate Quote "Hover Roof Design" gate:
 * hoverJobId && (Roof || RoofOnly) && Enable_Hover_Job === 'View'
 * (RRR alone does not qualify via OpportunityInterest.RoofOnly / Roof flags.)
 */
export function isHoverRoofDesignEnabled(options: {
    hoverJobId: string | null | undefined;
    opportunityDetails: any | null | undefined;
    onebuttonCapabilities: OneButtonUserCapabilityResponse | null | undefined;
}): boolean {
    const hoverJobId = options.hoverJobId;
    if (hoverJobId == null || String(hoverJobId).trim() === '') return false;

    const interest = options.opportunityDetails?.OpportunityInterest;
    const hasRoofInterest = !!(interest?.Roof || interest?.RoofOnly);
    if (!hasRoofInterest) return false;

    return getOneButtonCapabilityValue(options.onebuttonCapabilities, 'Enable_Hover_Job') === 'View';
}
